<script setup lang="ts">
import BaseButton from "@/core/components/base/BaseButton.vue";

defineProps<{
    laboratoryName: string;
    primaryColor?: string;
    secondaryColor?: string;
    laboratoryId: string;
}>();
</script>

<template>
  <div class="bg-white rounded-md shadow-2xl flex flex-col">
    <div class="flex items-baseline px-4 pt-4 justify-between">
      <h1 class="font-content-bold text-black">
        Passez commande
      </h1>
    </div>
    <div class="flex flex-col gap-4 h-full">
      <p class="px-4">
        Retrouvez tout le catalogue {{ laboratoryName }}, vos besoins de réassort calculés gamme par gamme, et
        remplissez votre panier en quelques clics.
      </p>
      <div class="h-full flex justify-center items-center min-h-24 relative w-full overflow-hidden">
        <BaseButton
          append-icon="mdi-cart"
          :color="primaryColor"
          :style="[
            'color: ' + (secondaryColor ?? '')
          ]"
          :to="{
            name: 'laboratory.needs',
            params: {laboratoryId}
          }"
        >
          Ouvrir le catalogue
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
